/**
 * localStorage keys owned by the app that hold user-session-scoped UI state.
 *
 * These persist column search history for the accounting-approval tables. They
 * are not tokens, but they leak the previous user's typed filter terms on a
 * shared machine, so they must be cleared on logout.
 */
export const REPORTS_COLUMN_SEARCH_HISTORY_KEY = "expense-admin:reports-column-search-history";
export const ITEMS_COLUMN_SEARCH_HISTORY_KEY = "expense-admin:items-column-search-history";

/** All session-scoped storage keys that must be wiped when the user logs out. */
export const SESSION_SCOPED_STORAGE_KEYS = [REPORTS_COLUMN_SEARCH_HISTORY_KEY, ITEMS_COLUMN_SEARCH_HISTORY_KEY] as const;

/** Removes every session-scoped storage key. Safe to call in any environment. */
export function clearSessionScopedStorage(): void {
    if (typeof window === "undefined") return;

    try {
        for (const key of SESSION_SCOPED_STORAGE_KEYS) {
            window.localStorage.removeItem(key);
        }
    } catch {
        // Ignore storage errors (for example, private mode quota limits).
    }
}
